<template>
  <div id="Header">
    <div class="row-header">
      <div class="col" id="logo_pulsar" v-if="target === 'localhost'"><img src="../assets/logo_light.png"/></div>
      <div v-else id="logo" :style="{ 'backgroundImage': 'url(\'' + urlImage + '\')' }"></div>

      <div class="col" id="title">
        <h4>CONFI-RACK <span style="font-size: 12px; font-weight: normal;">v3.3.0</span></h4>
      </div>
      <div v-if="version !== 'pl'" id="Languages" style="float: right;margin-right: 10px;position: absolute;top: 17px;right: 100px;">
        <ul class="navbar-nav ml-auto">
          <Languages/>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import image from '../img/logo.png'
import { versionApp } from '../config/i18n'
import Languages from './LocaleSwitcher'

export default {
  name: 'Header',
  data () {
    return {
      // image: image,
      version: versionApp,
      image: './img/logo_light.png',
      parentUrl: ''
    }
  },
  components: {
    Languages
  },
  computed: {
    target () {
      return process.env.VUE_APP_TARGET
    },
    urlImage () {
      // var server = window.location.origin
      // var currentUrl = window.location.pathname
      // return server + currentUrl + 'img/logo.png'
      return (this.parentUrl !== null && this.parentUrl !== undefined) ? this.parentUrl + 'img/logo_light.png' : 'img/logo_light.png'
    }
  },
  methods: {
    getURL () {
      return (this.imgPath)
    }
  },
  mounted () {
    let _this = this
    window.addEventListener('message', function (e) {
      _this.parentUrl = e.data.url
    })
    // var url = (window.location !== window.parent.location)
    //   ? document.referrer
    //   : document.location.href
    // this.parentUrl = url
    // var selfUrl = unescape(parent.window.location.pathname)
    // console.log(selfUrl)
    // console.log(window.top.location.href)
    // console.log(document.location.origin)
    // console.log(window.location.pathname)
    // console.log(document.location.href)
    // console.log(document.domain)
    // console.log(document.location.origin) // https://app.pulsar.pl
    // console.log(document.referrer) // http://dev.pulsar.pl/
    // console.log(encodeURIComponent(document.referrer)) // http://dev.pulsar.pl/
    // console.log(url) // http://dev.pulsar.pl/
    // console.log(document.location.pathname) // /confi-rack-test/
    // console.log(window.location.pathname) // /confi-rack-test/
    // console.log(window.parent.location.pathname)
    // console.log(window.parent.location)
    // console.log(window.top.location)
    // console.log(window.parent)
    // console.log(document.location)
    // console.log(window.location)
    // console.log(document.location)
  }
}
</script>

<style scoped>
#Header, .row-header {
  background: #404040;
  height: 80px;
}
#logo_pulsar{
width: 200px;
padding: 0px;
}
#title{
width: 336px;
height: 80px;
margin: 0px auto;
}
#title h4 {
  color: white;
  font-weight: bold;
  font-size: 40px;line-height: 70px;
}
#logo_bosch{
  width: 374px;
  height: 80px;
}
#nav {
  height: 80px;
  color: white;
  font-size: 36px;
  min-width: 75px;
  max-width: 100px;
  padding: 0px;
  cursor: pointer;
}
#nav svg {
  top:10px;position: relative;
}
#logo_pulsar img{
  height: 80px;
  float: left;
  padding: 10px;
  min-width: 190px;
}
#logo_bosch img{
  height: 80px;
}
#logo {
width: 200px;
background-size: 178px;
background-repeat: no-repeat;
height: 78px;
background-position: 8px 2px;
background-size: contain;
position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue